var render, staticRenderFns
import script from "./TournamentSelectItem.vue?vue&type=script&lang=tsx"
export * from "./TournamentSelectItem.vue?vue&type=script&lang=tsx"
import style0 from "./TournamentSelectItem.vue?vue&type=style&index=0&id=c4039808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4039808",
  null
  
)

export default component.exports